export { default as Footer } from './global/modules/Footer';
export { default as NotFound } from './global/404';
export { default as ErrorComponent } from './global/Error';
